import { render, staticRenderFns } from "./ModalJaleklinicoImagem.vue?vue&type=template&id=04c21e04&scoped=true"
import script from "./ModalJaleklinicoImagem.vue?vue&type=script&lang=js"
export * from "./ModalJaleklinicoImagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c21e04",
  null
  
)

export default component.exports